module.exports = __webpack_public_path__ + "static/media/yodastories1.e9ae89c7.gif";